import React, { useState, useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from "@material-ui/core/CircularProgress";
import ColAtm from "../../../../../atomic/Col/Col";
import {BASE_LIVE_WEB} from "../../../../../../constants/api.constants";

const styles = makeStyles({
    body: {
        background: '#ffffff'
    },
    root: {
        margin: 'auto',
        height: "100%",
        position: 'relative',
    },
    restrictInfo: {
        paddingTop: '24px'
    },
    spinnerOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(255, 255, 255, 0.85)',
        zIndex: 10,
    },
});

const WebForm = (props) => {
    const classes = styles();
    const nativeTheme = props?.currentTemplate || 'default';
    const themeParam = props?.selectedTheme && props?.selectedTheme !== nativeTheme
        ? '?theme=' + props?.selectedTheme
        : '';
    const url = BASE_LIVE_WEB + props?.token + '/' + props?.webDefaultLang + themeParam;

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
    }, [url]);

    return (
        <ColAtm container className={classes.root} direction="row" md={12}>
            {loading && (
                <div className={classes.spinnerOverlay}>
                    <CircularProgress color="secondary" className="preview-loading-spinner" size={48} />
                    <style>
                        {`
                            .preview-loading-spinner {
                                top:50% !important;
                            }
                        `}
                    </style>
                </div>
            )}
            <iframe
                id="previewFrame"
                name="previewFrame"
                className="site-preview-frame"
                src={url}
                title="preview-frame"
                onLoad={() => setLoading(false)}
            />
        </ColAtm>
    );
};

export default WebForm;